import { render } from "./notification.vue?vue&type=template&id=f3a2370e"
import script from "./notification.vue?vue&type=script&lang=ts"
export * from "./notification.vue?vue&type=script&lang=ts"
script.render = render

export default script